import Behaviour from '@/core';
import SponSlide from 'spon-slide';
import resizer from 'spon-resize';
import Hammer from 'hammerjs';

export default class SlideMobile extends Behaviour {
	constructor(el) {
		super(el);
		const viewport = resizer();

		const getSlideLength = () =>
			'<button class="c-carousel__pager-btn"></button>';

		this.slide = null;

		viewport.start();
		viewport.at('(min-width: 62em)', {
			match: () => {
				if (this.slide) {
					this.slide.destroy();
					this.slide = null;
				}
			},

			unmatch: () => {
				this.slide = new SponSlide(this.$el, {
					activeClass: 'is-current',
					loop: false,
					dots: true,
					paginationWrapper: '<div class="c-carousel__pager-wrapper"></div>',
					paginationButtons: slides => slides.map(getSlideLength),
				});

				this.slide.init();

				this.mc = new Hammer.Manager(this.$el);
				this.mc.add(
					new Hammer.Swipe({
						direction: 6,
					})
				);
				this.mc.on('swipeleft', () => this.slide.next());
				this.mc.on('swiperight', () => this.slide.next());
			},
		});
	}
}


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
